import { Controller } from "@hotwired/stimulus";
import { nextIndex, swipeDirection } from "../lib/gallery";
export default class extends Controller {
  static targets = ["image", "caption"];
  connect() {
    this.openHandler = (event) => this.open(event.detail.trigger);
    this.cacheHandler = () => { if(this.element.open) this.element.close(); };
    this.closeHandler = () => { this.trigger?.focus(); };
    this.element.addEventListener("gallery:open", this.openHandler);
    this.element.addEventListener("close", this.closeHandler);
    document.addEventListener("turbo:before-cache", this.cacheHandler);
  }
  disconnect() { this.element.removeEventListener("gallery:open", this.openHandler); this.element.removeEventListener("close", this.closeHandler); document.removeEventListener("turbo:before-cache", this.cacheHandler); }
  open(trigger) { this.trigger = trigger; this.sources = [...document.querySelectorAll(".gallery-source")]; this.index = this.sources.indexOf(trigger); this.show(); this.element.showModal(); }
  show() { const source = this.sources[this.index]; if(!source) return; this.imageTarget.src = source.href; this.imageTarget.alt = source.dataset.galleryAlt || ""; this.captionTarget.textContent = `${this.index + 1} / ${this.sources.length} — ${this.imageTarget.alt}`; }
  close() { this.element.close(); }
  previous() { this.index = nextIndex(this.index, -1, this.sources.length); this.show(); }
  next() { this.index = nextIndex(this.index, 1, this.sources.length); this.show(); }
  key(event) { if(event.key === "ArrowLeft") this.previous(); if(event.key === "ArrowRight") this.next(); }
  backdrop(event) { if(event.target === this.element) this.close(); }
  touchStart(event) { this.touchX = event.changedTouches[0].screenX; }
  touchEnd(event) { const direction = swipeDirection(this.touchX, event.changedTouches[0].screenX); if(direction > 0) this.next(); if(direction < 0) this.previous(); }
}
